









import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getAppStatus } from '@/api/files/files-app/filesApp'
import { EStateColor } from '../../typings/enum'
@Component({
  name: 'status-select'
})
export default class extends Vue {
  @Prop({ required: true }) private value!: string

  private model: string = this.value
  private options: any[] = []
  public stateColor = EStateColor

  created() {
    this.getAppStatus()
  }

  async getAppStatus() {
    let res = await getAppStatus()
    this.options = res.data
  }

  @Watch('value')
  private onChange(newVal: string) {
    this.model = newVal
  }
}
